import { CalendarDays, type LucideIcon } from "lucide-react";
import { canAccessClubBookings, CLUB_BOOKING_ACCESS_ROLES } from "@shared/clubBookingAccess";
import type { UserRoleFields } from "@shared/userRoles";

export const CLUB_BOOKING_NAV_ITEM = {
  icon: CalendarDays as LucideIcon,
  label: "CLUB",
  path: "/club-bookings",
  roles: CLUB_BOOKING_ACCESS_ROLES,
};

export function showClubBookingNav(user: UserRoleFields | null | undefined): boolean {
  return canAccessClubBookings(user);
}

export function isClubBookingNavActive(location: string): boolean {
  const path = (location.split("?")[0] ?? location).replace(/\/+$/, "") || "/";
  return path === CLUB_BOOKING_NAV_ITEM.path;
}
